const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    /^127(?:\.\d{1,3}){3}$/.test(window.location.hostname)
);

export function registerServiceWorker({ onUpdate, onSuccess } = {}) {
  // if (process.env.NODE_ENV !== 'production') {
  //   return;
  // }

  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, onUpdate, onSuccess);
    } else {
      registerValidServiceWorker(swUrl, onUpdate, onSuccess);
    }
  });
}

function registerValidServiceWorker(swUrl, onUpdate, onSuccess) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('Service worker registered.');

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;

        if (!installingWorker) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('New version available.');

              if (onUpdate) {
                onUpdate(registration);
              }
            } else {
              console.log('Application is ready for offline use.');

              if (onSuccess) {
                onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Service worker registration failed:', error);
    });
}

function checkValidServiceWorker(swUrl, onUpdate, onSuccess) {
  fetch(swUrl, {
    headers: {
      'Service-Worker': 'script'
    }
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');

      if (response.status === 404 || (contentType && !contentType.includes('javascript'))) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });

        return;
      }

      registerValidServiceWorker(swUrl, onUpdate, onSuccess);
    })
    .catch(() => {
      console.log('No internet connection found. App is running from the cached version.');
    });
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
